import React, {createContext, useContext, useState} from "react";
import {CircularProgress} from "@mui/material";
import {AppComponent} from "../App";
import css from "../css/loading.module.css"

export const AppContext = createContext({});

const LoadingElement = () => {
    const {loading} = useContext(AppContext);

    return loading && (
        <div className={css.loading}>
            <div className={css.background}/>
            <div className={css.container}>
                <CircularProgress className={"loading"}/>
            </div>
        </div>
    )
}

export const Loading = ({children}) => {
    const [loading, setLoading] = useState(false);

    AppComponent.SetLoading = (data) => setLoading(data);

    return (
        <AppContext.Provider value={{loading}}>
            <LoadingElement/>
            {children}
        </AppContext.Provider>
    )
}
